import ButtonDeleteFile from './ButtonDeleteFile-redux';

export default ButtonDeleteFile;
